/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommentsType } from './commentsType';


export interface ErrorType { 
    errorKind: ErrorType.ErrorKindEnum;
    comments?: CommentsType;
}
export namespace ErrorType {
    export const ErrorKindEnum = {
        NotValid: 'NOT_VALID',
        FileWithoutReference: 'FILE_WITHOUT_REFERENCE',
        ReferenceWithoutFile: 'REFERENCE_WITHOUT_FILE',
        UnknownRecipient: 'UNKNOWN_RECIPIENT'
    } as const;
    export type ErrorKindEnum = typeof ErrorKindEnum[keyof typeof ErrorKindEnum];
}


